<div class="np-overlay" [class.open]="open" (click)="close()"></div>

<aside class="np-panel" [class.open]="open" role="dialog" aria-label="Notifications">
  <div class="np-hdr">
    <div class="np-title">
      <ng-icon name="tablerBell"></ng-icon>
      Notifications
      <span class="np-count-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
    </div>
    <div class="np-actions">
      <button type="button" class="np-mark-all"
              *ngIf="canMarkAllRead && unreadCount > 0"
              [class.is-busy]="markingAllRead"
              [disabled]="markingAllRead"
              (click)="onMarkAllRead()">
        <span class="np-mark-all-spinner" *ngIf="markingAllRead"></span>
        {{ markingAllRead ? 'Marking…' : 'Mark all read' }}
      </button>
      <button type="button" class="np-close" (click)="close()" aria-label="Close">
        <ng-icon name="tablerX"></ng-icon>
      </button>
    </div>
  </div>

  <div class="np-list" (scroll)="onListScroll($event)">
    <div class="np-loading" *ngIf="loading && !notifications.length">Loading…</div>

    <div class="np-item"
         *ngFor="let n of notifications"
         [class.unread]="n.unread"
         (click)="onItemClick(n)">
      <!-- Same avatar as the /notifications page left column: photo / logo /
           fixed icon, or initials on the name-derived colours. -->
      <div class="np-avatar"
           [class.np-av-initials]="n.avatar.kind === 'initials'"
           [style.background-color]="initialsBg(n)"
           [style.color]="initialsFg(n)">
        <img *ngIf="n.avatar.kind === 'image'" [src]="n.avatar.src" alt="" class="np-avatar-img"
             (error)="$any($event.target).style.display='none'">
        <span *ngIf="n.avatar.kind === 'initials'" class="np-avatar-initials">{{ initials(n) }}</span>
      </div>
      <div class="np-content">
        <div class="np-item-title" [title]="n.title">{{ n.title }}</div>
        <app-notification-message class="np-item-body compact" [item]="n.raw" [showActions]="false"></app-notification-message>
      </div>
      <div class="np-time">{{ n.time }}</div>
    </div>

    <div class="np-loading-more" *ngIf="loadingMore && notifications.length">
      Loading more…
    </div>

    <div class="np-empty" *ngIf="!loading && !notifications.length">
      You're all caught up!
    </div>
  </div>

  <div class="np-footer">
    <button type="button" class="np-view-all" (click)="onViewAll()">
      View all notifications
    </button>
  </div>
</aside>
